import {css, html, LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
import {HoversliderSlideComponent} from './HoversliderSlideComponent';

@customElement('hover-slider')
export class HoversliderComponent extends LitElement {
  static slideActiveClass = 'active';

  static styles = css`
    slot {
      width: 100%;
      height: var(--height);
      max-height: var(--max-height);
      display: flex;
      gap: var(--gap);
      justify-content: space-between;
    }

    @media only screen and (max-width: 1023px) {
      slot {
        flex-wrap: wrap;
        height: auto;
        max-height: none;
      }
    }

    ::slotted(hover-slider-slide[active]) {
      flex-grow: var(--flex-grow-active);
    }
  `;

  render() {
    return html`
      <slot @slotchange=${this._handleSlotchange}></slot>
    `;
  }

  private _slides() {
    const slot = this.shadowRoot?.querySelector('slot');
    if (!slot) {
      return [];
    }
    return <HoversliderSlideComponent[]>slot.assignedElements();
  }

  private _handleSlotchange(ev: Event) {
    this._slides().forEach(
      el => {
        el.addEventListener('pointerenter', ev => this._handleSlideMouseEnter(ev));
        el.addEventListener('pointermove', ev => this._handleSlideMouseEnter(ev));
      },
    );
  }

  private _handleSlideMouseEnter(ev: Event) {
    const currentSlide: HoversliderSlideComponent = <HoversliderSlideComponent>ev.currentTarget;
    this._slides().forEach(
      slide => {
        slide.active = slide === currentSlide;
        slide.play = slide.active;
      },
    );
  }
}
